module.exports = __webpack_public_path__ + "static/media/search.28885579.svg";